import { Box, type SxProps, type Theme } from "@mui/material";
import type { FC } from "react";

interface JumpingDotsProps {
	/** Dot diameter in px. Default 4. */
	size?: number;
	/** MUI color token for dots. Default "text.secondary". */
	color?: string;
	/** Extra sx on the root container. */
	sx?: SxProps<Theme>;
}

/**
 * Three dots that bounce in sequence — a lightweight inline loading indicator.
 */
export const JumpingDots: FC<JumpingDotsProps> = ({ size = 4, color = "text.secondary", sx }) => (
	<Box sx={{ display: "flex", gap: `${Math.round(size * 0.75)}px`, alignItems: "center", justifyContent: "center", ...sx }}>
		{[0, 1, 2].map((i) => (
			<Box
				key={i}
				sx={{
					width: size,
					height: size,
					borderRadius: "50%",
					bgcolor: color,
					animation: "jumpingDotsBounce 0.6s infinite",
					animationDelay: `${i * 0.15}s`,
					"@keyframes jumpingDotsBounce": {
						"0%, 100%": { transform: "translateY(0)" },
						"50%": { transform: "translateY(-4px)" },
					},
					"@media (prefers-reduced-motion: reduce)": { animation: "none" },
				}}
			/>
		))}
	</Box>
);
